import { FaCirclePlus } from "react-icons/fa6";


const PortFolio = () => {

    return (
        <section id="portfolio" className="portfolio-mf sect-pt4 route">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="title-box text-center">
                            <h3 className="title-a">
                                Portfolio
                            </h3>
                            <p className="subtitle-a">
                                Proyectos personales en desarrollo durante mi tiempo libre
                            </p>
                            <div className="line-mf"></div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-1.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-1.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title" style={{ fontSize: '17px' }}>Decentralized Instant Payments</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">Web3,Blockchain</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/dip"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-2.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-2.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title">LuxTrace</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">Web3,Blockchain</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/luxtrace"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-3.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-3.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title">Blocklit</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">Web3, Blockchain</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/blocklit"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-6.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-6.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title" style={{ fontSize: '17px' }}>Decentralized Voting System</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">Web3, Blockchain</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/voting"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-4.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-4.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title">Comidix AI</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">App mobile, Deep Learning</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/comidix"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="work-box">
                            <a href="assets/img/work-5.jpg" data-gallery="portfolioGallery" className="portfolio-lightbox">
                                <div className="work-img">
                                    <img src="assets/img/work-5.jpg" alt="" className="img-fluid" />
                                </div>
                            </a>
                            <div className="work-content">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <h2 className="w-title">Match Book</h2>
                                        <div className="w-more">
                                            <span className="w-ctegory">Web Design</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="w-like">
                                            <a href="/project/mbook"> <FaCirclePlus className="bi bi-plus-circle" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default PortFolio